import { render, staticRenderFns } from "./IndustryOverview.vue?vue&type=template&id=74d66846&scoped=true"
import script from "./IndustryOverview.vue?vue&type=script&lang=js"
export * from "./IndustryOverview.vue?vue&type=script&lang=js"
import style0 from "./IndustryOverview.vue?vue&type=style&index=0&id=74d66846&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d66846",
  null
  
)

export default component.exports